
export const commonMessage = {
    somethingWrong: () => `Something went wrong!`,
    notFound: (title) => `${title} Not Found!`,
}